/* Header — mobile nav drawer. Ported from the Woo SiteHeader burger + MobileNav.
 * The burger toggles a full-viewport drawer below the header; nested menu links
 * expand as accordions. Body scroll locks while open; Esc / tapping a link close.
 * Desktop is unaffected (the burger + drawer are mobile-only via CSS).
 */
(function () {
  var toggle = document.querySelector('[data-mobile-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (!toggle || !nav) return;
  var header = document.querySelector('.site-header');

  // Anchor the drawer just below the (variable-height) header.
  function syncTop() { if (header) nav.style.top = header.offsetHeight + 'px'; }

  function open() {
    syncTop();
    nav.hidden = false;
    toggle.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    nav.hidden = true;
    toggle.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', function () { nav.hidden ? open() : close(); });

  nav.querySelectorAll('[data-mobile-acc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.mobile-nav__item');
      var isOpen = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  // Close when a real link is tapped (navigation follows).
  nav.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !nav.hidden) close(); });
  window.addEventListener('resize', function () {
    if (window.matchMedia('(min-width: 500px)').matches && !nav.hidden) close();
    else if (!nav.hidden) syncTop();
  });
})();

/* Header — desktop mega-menu. Hover a top nav item to reveal its full-width
 * dropdown panel. Open/close is tracked on the whole .site-header so moving the
 * cursor from the item down across the bar gap into the panel keeps it open
 * (the panel is a DOM descendant of .site-header, so leaving the bar area but
 * staying inside the header doesn't fire mouseleave). Keyboard = :focus-within
 * (CSS). Mobile hides the panels via CSS; this is desktop-only in effect. */
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  var items = header.querySelectorAll('.site-header__nav-item');
  if (!items.length) return;
  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      items.forEach(function (i) { i.classList.toggle('is-open', i === item); });
    });
  });
  header.addEventListener('mouseleave', function () {
    items.forEach(function (i) { i.classList.remove('is-open'); });
  });
})();

/* Header — hide on scroll-down, reveal on scroll-up (past 90px). Ported from Woo
 * (SiteHeader hides `translateY(-100%)` past 90px, re-shows on up-scroll). The
 * class goes on the sticky section WRAPPER (the element that's actually sticky).
 * Suppressed while a header overlay is open (predictive search / mobile drawer). */
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  var wrap = header.closest('.shopify-section') || header;
  var lastY = window.pageYOffset || 0;
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = window.pageYOffset || 0;
      var overlayOpen = document.querySelector('[data-search-overlay]:not([hidden]), [data-mobile-nav]:not([hidden])');
      if (!overlayOpen && y > 90 && y > lastY) wrap.classList.add('is-header-hidden');
      else if (y < lastY) wrap.classList.remove('is-header-hidden');
      lastY = y;
    });
  }, { passive: true });
})();
